import type { GetStaticPaths, GetStaticProps, NextPage } from 'next'

import { supportedLanguages } from '~/data/lang/settings'
import type { ArticlesPageData } from '~/utils/articles/getArticlesPageProps'
import { getArticlesPageProps } from '~/utils/articles/getArticlesPageProps'
import type { IPaginationContext } from '~/utils/doPagination'
import { addTranslations } from '~/utils/i18n'
import { withLocalizedSettings } from '~/utils/withLocalizedSettings'

import CategoryArticlesPage from '../../edition/[category]'

const ArtistArticlesPage: NextPage<ArticlesPageData> = (
  props: ArticlesPageData
) => {
  return <CategoryArticlesPage {...props} />
}

const getStaticPropsOriginal: GetStaticProps = async function getStaticProps(
  context
) {
  const { lang } = context.params as any
  const validLanguages = ['en', ...supportedLanguages]

  if (!validLanguages.includes(lang)) {
    return {
      notFound: true,
    }
  }

  try {
    const categoryParam = context.params?.slug as string | undefined

    // Get SEO templates from centralized _app.tsx loading
    const seoTemplates = (context as any)?.pageProps?.seoTemplates
    const pageProps = await getArticlesPageProps(
      context as IPaginationContext,
      seoTemplates,
      categoryParam,
      true
    )

    const isArtist = context.params?.slug?.includes('artist-')

    if (!isArtist) {
      return {
        notFound: true,
      }
    }

    return {
      props: {
        ...pageProps,
        notFound: false,
      },
    }
  } catch (error) {
    console.error('Error in getStaticProps:', error)

    return {
      notFound: true,
    }
  }
}

// Add SSR translation support
export const getStaticProps = withLocalizedSettings(async context => {
  const result = await getStaticPropsOriginal(context)

  if ('props' in result) {
    return {
      props: await addTranslations(result.props, context),
    }
  }

  return result
})

export const getStaticPaths: GetStaticPaths = async () => ({
  paths: [],
  fallback: 'blocking',
})

export default ArtistArticlesPage
